<template>
    <div class="section" dir="rtl">
        <div class="container">
            <div class="breadcrumb mb-10 text-bold" > {{  $t('agency.title') }} > {{  $t('vigilance.title') }} </div>
        </div>
    </div>

    <div class="container" dir="rtl" >
        <div class="title">{{  $t('vigilance.title') }}</div>

        <div class="row mb-5">
            <div class="px-lg-5 ressource mt-5 mb-5 " >
                <div class="container d-flex pb-5 card-bloc">

                    <div class="card-group row mt-5">
                        <div class="cadre col-12 col-md-6 px-xl-5">
                            <div class="cadre__inner" >
                                <a :href="'pdf/vigilance/ANSS_BVH19_2025.pdf'" target="_blank" >Bulletin de veille hebdomadaire n°19
                                    <br><span>Semaine du 05/05/2025 au 12/05/2025 </span>
                                </a>
                                <a :href="'pdf/vigilance/ANSS_BVH19_2025.pdf'" download target="_blank" > <font-awesome-icon class="fa-2x" icon="fa fa-download fa-2x" />&nbsp; </a>
                            </div>
                        </div>
                        <div class="cadre col-12 col-md-6 px-xl-5">
                            <div class="cadre__inner" >
                                <a :href="'pdf/vigilance/ANSS_BVH18_2025.pdf'" target="_blank" >Bulletin de veille hebdomadaire n°18
                                    <br><span>Semaine du 28/04/2025 au 05/05/2025</span>
                                </a>
                                <a :href="'pdf/vigilance/ANSS_BVH18_2025.pdf'" download target="_blank" > <font-awesome-icon class="fa-2x" icon="fa fa-download fa-2x" />&nbsp; </a>
                            </div>
                        </div>
                        <div class="cadre col-12 col-md-6 px-xl-5">
                            <div class="cadre__inner" >
                                <a :href="'pdf/vigilance/ANSS_BVH17_2025.pdf'" target="_blank" >Bulletin de veille hebdomadaire n°17
                                    <br><span>Semaine du 21/04/2025 au 28/04/2025</span>
                                </a>
                                <a :href="'pdf/vigilance/ANSS_BVH17_2025.pdf'" download target="_blank" > <font-awesome-icon class="fa-2x" icon="fa fa-download fa-2x" />&nbsp; </a>
                            </div>
                        </div>
                        <div class="cadre col-12 col-md-6 px-xl-5">
                            <div class="cadre__inner" >
                                <a :href="'pdf/vigilance/ANSS_ BVH51.pdf'" target="_blank" >Bulletin de veille hebdomadaire n°51
                                    <br><span>Semaine du 29/09/2024 au 05/10/2024</span>
                                </a>
                                <a :href="'pdf/vigilance/ANSS_ BVH51.pdf'" download target="_blank" > <font-awesome-icon class="fa-2x" icon="fa fa-download fa-2x" />&nbsp; </a>
                            </div>
                        </div>
                        <div class="cadre col-12 col-md-6 px-xl-5">
                            <div class="cadre__inner" >
                                <a :href="'pdf/vigilance/ANSS_ BVH52.pdf'" target="_blank" >Bulletin de veille hebdomadaire n°52
                                    <br><span>Semaine du 06/10/2024 au 12/10/2024</span>
                                </a>
                                <a :href="'pdf/vigilance/ANSS_ BVH52.pdf'" download target="_blank" > <font-awesome-icon class="fa-2x" icon="fa fa-download fa-2x" />&nbsp; </a>
                            </div>
                        </div>
                        <div class="cadre col-12 col-md-6 px-xl-5">
                            <div class="cadre__inner" >
                                <a :href="'pdf/vigilance/ANSS_ BVH53.pdf'" target="_blank" >Bulletin de veille hebdomadaire n°53
                                    <br><span>Semaine du 13/10/2024 au 19/10/2024</span>
                                </a>
                                <a :href="'pdf/vigilance/ANSS_ BVH53.pdf'" download target="_blank" > <font-awesome-icon class="fa-2x" icon="fa fa-download fa-2x" />&nbsp; </a>
                            </div>
                        </div>
                        <div class="cadre col-12 col-md-6 px-xl-5">
                            <div class="cadre__inner" >
                                <a :href="'pdf/vigilance/ANSS_ BVH54.pdf'" target="_blank" >Bulletin de veille hebdomadaire n°54
                                    <br><span>Semaine du 20/10/2024 au 26/10/2024</span>
                                </a>
                                <a :href="'pdf/vigilance/ANSS_ BVH54.pdf'" download target="_blank" > <font-awesome-icon class="fa-2x" icon="fa fa-download fa-2x" />&nbsp; </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "vigilance",
    }
</script>

<style scoped>

    .centre-title {
        width: 100%;
        max-width: 100%;
        display: flex;
        font-size: var(--xl-font-size);
        font-weight: 700;
        justify-content: center;
        margin-bottom: 20px;
    }
    .centre-title .quote{
        color: var(--green);;
        font-size: var(--m-font-size);
        vertical-align: text-top!important;

    }
    .card-bloc{
        box-shadow: 5px 5px 30px #5a6268;
        min-height: 400px;
        justify-content: center;
        flex-direction: column-reverse
    }

    .card-group .cadre .cadre__inner{
        background-color: rgba(255,204,0, 0.7);
        /*margin: 10px 20px;*/
        margin-top: 20px;
        box-shadow: 5px 5px 20px #051a27;
        height: 120px;
        /*padding-top: 20px;*/
        border-radius: 4px;
        display: flex;
        align-content: space-between;
        justify-content: space-between;
        padding-left: 15px;
        padding-right: 15px;
    }
    .card-group .cadre .cadre__inner a{
        padding:7px 15px;
        color: #282a2e !important;
        font-size:var(--m-font-size);
        text-decoration: none;
        text-shadow: 0 0 5px rgb(250, 250, 250);
    }
    .card-group .cadre .cadre__inner a:hover,.card-group .cadre .cadre__inner i:hover{
        color: black !important;
        font-weight: bold;
        text-shadow: 0 2px 2px rgb(250, 250, 250);


    }
    .card-group .cadre .cadre__inner i{
        color:gray;
        vertical-align: middle;
        box-shadow: 5px 5px 10px #000000;

    }
    .cadre__inner{
        direction: ltr;
    }
    .card-group{
        padding-top: auto;
        padding-bottom: auto;
    }

    @media(max-width: 415px){
        .card-bloc{
            box-shadow: 5px 5px 30px #5a6268;
            /*height: 500px;*/
            justify-content: center;
            flex-direction: column-reverse
        }

        .card-group .cadre .cadre__inner{
            padding-top: 7px!important;
            height: 140px !important;
            padding-left: 5px;
            padding-right: 5px;
        }
        .cadre__inner a{
            padding-left: 5px;
            padding-right: 5px;
            line-height: 1.3;
            font-size: var(--s-font-size);
        }
    }

</style>